/**
 * List Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('InsertionOrderIndexController', [
    '$scope',
    '$timeout',
    'insertionOrderApi',
    'optionsApi',
    function($scope, $timeout, insertionOrderApi, optionsApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.loading = false;

      $scope.list = null;

      $scope.page = {
        number: 0,
        size: 10,
      };

      $scope.statusFilter = ['running','not_started','paused'];

      $scope.$watch('statusFilter', function(newVal, oldVal) {
          if (newVal && oldVal && newVal !== oldVal) {
              $scope.fetch();
          }
      }, true);

      var storedSearchTerm = window.localStorage.getItem('ioSearchTerm');
      if (storedSearchTerm) {
        $scope.searchTerm = storedSearchTerm;
      } else {
        $scope.searchTerm = '';
      }

      var storedSelectedAdvertiser = parseInt(window.localStorage.getItem('advertiserFilter'));
      if (storedSelectedAdvertiser) {
        $scope.advertiserFilter = storedSelectedAdvertiser;
      } else {
        $scope.advertiserFilter = window.selectedAdvertiser
          ? window.selectedAdvertiser
          : '*';
      }

      $scope.sort = {
        field: 'ts_updated',
        order: 'desc',
      };

      var filterTimeout = null;
      $scope.$watch('searchTerm', function(newVal, oldVal) {
        if (newVal == oldVal) {
          return;
        }

        window.localStorage.setItem('ioSearchTerm', $scope.searchTerm);

        if (filterTimeout) {
          $timeout.cancel(filterTimeout);
        }

        filterTimeout = $timeout(function() {
          $scope.filter();
        }, 700);
      });

      $scope.$watch('advertiserFilter', function(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          window.localStorage.setItem('advertiserFilter', $scope.advertiserFilter);
          $scope.filter();
        }
      });

      $scope.filter = function() {
        $scope.page.number = 0;

        $scope.fetch();
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;
        insertionOrderApi
          .getList(
            $scope.sort,
            $scope.searchTerm,
            $scope.page,
            $scope.advertiserFilter,
            $scope.statusFilter
          )
          .then(
            function(data) {
              $scope.list = {
                count: data.count,
                data: data.data,
                maxPage: Math.floor(data.count / $scope.page.size),
              };
              if (data.data.length > 0) {
                var io_list = [];
                for (var i = 0; i < data.data.length; i++) {
                  io_list.push(data.data[i]['_id']);
                }
                if (optionsApi.isUseCdp()) {
                  insertionOrderApi.getStatCDP(io_list).then(function (stat) {
                    for (i = 0; i < $scope.list.data.length; i++) {
                      var ioid = $scope.list.data[i]['_id'];
                      $scope.list.data[i].budget_spent = stat[ioid] ? stat[ioid].sum_cost / 1000000 : 0;
                      $scope.list.data[i].ctr_stat = stat[ioid] && stat[ioid].impressionsTotal
                          ? ((stat[ioid].clicksTotal / stat[ioid].impressionsTotal) * 100).toString()
                          : '0';
                      $scope.list.data[i].imps_stat = stat[ioid] && stat[ioid].impressionsStr ? stat[ioid].impressionsStr : 'N/A';
                      $scope.list.data[i].clicks_stat = stat[ioid] && stat[ioid].clicksStr ? stat[ioid].clicksStr : 'N/A';
                    }
                  });
                } else {
                  insertionOrderApi.getCampaignStat(io_list).then(function (stat) {
                    var stat_hash = {};
                    for (var i = 0; i < stat.length; i++) {
                      if (!stat_hash[stat[i]['ref_insertion_order_id']]) {
                        stat_hash[stat[i]['ref_insertion_order_id']] = {
                          n_impression: 0,
                          imps_total_goal: 0,
                          sum_cost: 0,
                          n_click: 0
                        };
                      }
                      stat_hash[stat[i]['ref_insertion_order_id']]['n_impression'] += stat[i]['n_impression'];
                      stat_hash[stat[i]['ref_insertion_order_id']]['sum_cost'] += stat[i]['sum_cost'];
                      stat_hash[stat[i]['ref_insertion_order_id']]['n_click'] += stat[i]['n_click'];

                      switch (stat[i]['campaign_goal_type']) {
                        case 1:  // per day
                          var active_days = Math.floor((stat[i]['campaign_end'] - stat[i]['campaign_start']) / (60 * 60 * 24)).toFixed();
                          var total_goal = stat[i]['campaign_goal_value'] * active_days;
                          stat_hash[stat[i]['ref_insertion_order_id']]['imps_total_goal'] += total_goal;
                          break;
                        case 2: // total
                          stat_hash[stat[i]['ref_insertion_order_id']]['imps_total_goal'] += stat[i]['campaign_goal_value'];
                          break;
                      }

                    }


                    for (i = 0; i < $scope.list.data.length; i++) {
                      $scope.list.data[i].imps_stat = stat_hash[$scope.list.data[i]['_id']]
                          ? stat_hash[$scope.list.data[i]['_id']].n_impression.toString() + " / " + stat_hash[$scope.list.data[i]['_id']].imps_total_goal.toString() + "; "
                          : "0; ";
                      $scope.list.data[i].budget_spent = stat_hash[$scope.list.data[i]['_id']]
                          ? stat_hash[$scope.list.data[i]['_id']].sum_cost / 1000000
                          : 0;
                      $scope.list.data[i].clicks_stat = stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_click
                          ? stat_hash[$scope.list.data[i]['_id']].n_click.toString() + "; "
                          : "0 ;";

                      $scope.list.data[i].ctr_stat = stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_impression
                          ? ((stat_hash[$scope.list.data[i]['_id']].n_click / stat_hash[$scope.list.data[i]['_id']].n_impression) * 100).toString()
                          : '0';
                    }

                    // today stat
                    insertionOrderApi.getCampaignStatToday(io_list).then(function (stat) {
                      var stat_hash = {};
                      for (var i = 0; i < stat.length; i++) {
                        if (!stat_hash[stat[i]['ref_insertion_order_id']]) {
                          stat_hash[stat[i]['ref_insertion_order_id']] = {
                            n_impression: 0,
                            imps_total_goal: 0,
                            sum_cost: 0,
                            n_click: 0
                          };
                        }
                        stat_hash[stat[i]['ref_insertion_order_id']]['n_impression'] += stat[i]['n_impression'];
                        stat_hash[stat[i]['ref_insertion_order_id']]['sum_cost'] += stat[i]['sum_cost'];
                        stat_hash[stat[i]['ref_insertion_order_id']]['n_click'] += stat[i]['n_click'];

                        switch (stat[i]['campaign_goal_type']) {
                          case 1:  // per day
                            stat_hash[stat[i]['ref_insertion_order_id']]['imps_total_goal'] += stat[i]['campaign_goal_value'];
                            break;
                          case 2: // total
                            var days = Math.floor((stat[i]['campaign_end'] - stat[i]['campaign_start']) / (60 * 60 * 24));
                            var per_day_goal = stat[i]['campaign_goal_value'] / days;
                            stat_hash[stat[i]['ref_insertion_order_id']]['imps_total_goal'] += per_day_goal;
                            break;
                        }
                      }


                      for (i = 0; i < $scope.list.data.length; i++) {
                        $scope.list.data[i].imps_stat += stat_hash[$scope.list.data[i]['_id']]
                            ? stat_hash[$scope.list.data[i]['_id']].n_impression.toString() + " / " + stat_hash[$scope.list.data[i]['_id']].imps_total_goal.toFixed().toString() + ""
                            : "0 / 0";
                        $scope.list.data[i].clicks_stat += stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_click
                            ? stat_hash[$scope.list.data[i]['_id']].n_click.toString()
                            : "0";

                      }
                    });


                  });
                }



              }
              $scope.loading = false;
            },
            function() {
              $scope.list = {
                count: 0,
                data: [],
                maxPage: null,
              };
              $scope.loading = false;
            }
          );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      /**
       * toggle IO active/inactive
       * @param io
       */
      $scope.toggleActive = function(io) {
        insertionOrderApi.toggleActive(io._id).then(function() {
          io.active = !io.active;
        });
      };

      /**
       * show the delete confirmation dialog
       * @param io
       */
      $scope.promptDelete = function(io) {
        $scope.ioToDetele = io;
        $('#delete-modal').modal('show');
      };

      /**
       * delete an IO
       * @param io
       */
      $scope.delete = function(io) {
        insertionOrderApi.delete(io._id).then(function() {
          $scope.fetch();
        });
      };

      /**
       * export list to csv
       */
      $scope.export = function() {
        var url = '/demandmgr/insertion-order/export';

        url = url + '?sortField=' + $scope.sort.field;
        url = url + '&sortOrder=' + $scope.sort.order;
        url = url + '&search=' + $scope.searchTerm;

        window.location.href = url;
      };

      /**
       * open an IO creating/editing form
       * @param ioId
       */
      $scope.openIOForm = function(ioId) {
        window.location.href = '/#!/demandmgr/insertion-order/edit?id=' + ioId;
      };

      $scope.drillDown = function(id) {
        window.location.href = '/#!/demandmgr/campaign?insertion-order=' + id;
      };
      
      $scope.getTitle = function (status) {
        var statusTitle = '';
        switch (status) {
          case 'Active':
            statusTitle = 'Active: at least one campaign is currently delivering';
            break;
          case 'Paused':
            statusTitle = 'Paused: at least one campaign exists for the time frame and could be delivering but the campaign is disabled';
            break;
          case 'Ready':
            statusTitle = 'Ready: at least one campaign is active but will start delivery in the future';
            break;
          case 'Expired':
            statusTitle = 'Expired: at least one campaign is active but has an end date in the past, i. e. has already completed';
            break;
          case 'Inactive':
            statusTitle = 'Inactive: no active campaigns';
            break;
        }

        return statusTitle;
      };

      $scope.fetch();
    },
  ]);
})(window.angular);

/**
 * IO Edit Campaign Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');
  app.controller('InsertionOrderEditCampaignController', [
    '$scope',
    '$http',
    'insertionOrderApi',
    'campaignApi',
    function($scope, $http, insertionOrderApi, campaignApi) {
      /**
       * fetch all assigned campaigns
       */
      var fetch = function() {
        insertionOrderApi.getCampaigns(window.ioId).then(
          function(res) {
            $scope.campaigns = res.data;
          },
          function() {
            console.error('could not load campaigns');
          }
        );
      };

      if (window.ioId) {
        fetch();
      }

      /**
       * toggle active status of given campaigns
       *
       * @param ids
       */
      $scope.toggleCampaignActive = function(ids) {
        campaignApi.toggleActive(ids).then(
          // success
          function() {
            fetch();
          },
          // error
          function() {
            console.error('could not update campaign');
          }
        );
      };

      $scope.promptStopAllCampaigns = function() {
        $('#stop-campaigns-modal').modal('show');
      };

      /**
       * stop all campaigns
       */
      $scope.stopAllCampaigns = function() {
        var ids = [];
        $scope.campaigns.forEach(function(campaign) {
          if (campaign.active === 1) {
            ids.push(campaign._id);
          }
        });
        ids = ids.join(',');

        $scope.toggleCampaignActive(ids);
      };

      /**
       * open campaign edit form
       * @param campaign
       */
      $scope.openCampaignForm = function(campaign) {
        window.open('/#!/demandmgr/campaign/edit?id=' + campaign._id, '_blank');
      };
    },
  ]);
})(window.angular);
